import { DatePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'consultationHeading'
})
export class ConsultationHeadingPipe implements PipeTransform {

	title: string

	constructor(private datePipe: DatePipe) {

	}

	transform(consultation: any, args?: any): any {
		if (consultation) {
			if (consultation.type) {
				this.title = consultation.type.libelle
			}
			if (consultation.domicile) {
				this.title += ' - ' + 'A domicile'
			}
			if (consultation.ponctuel) {
				this.title += ' - ' + 'Non planifié'
			}
			if (consultation.date_debut) {
				this.title += ' du ' + this.datePipe.transform(consultation.date_debut, 'EEEE d MMMM yyyy HH:mm')
			}
			if (consultation.date_fin) {
				this.title += ' au ' + this.datePipe.transform(consultation.date_fin, 'EEEE d MMMM yyyy HH:mm')
			}
		}
		return this.title
	}
}
